import formAppThirdPartyAuthProviderSetup from './formAppThirdPartyAuthProviderSetup';
import formAppThirdPartyAuthProviderAppearance from './formAppThirdPartyAuthProviderAppearance';


export default {
  title: 'Team Blackouts TBD',
  attributeName:'thirdPartyAuthProvider',
  createURL: '',
  sessionParams: [],
  getURL: 'sportrooms/appId/teamblackouts',
  updateURL: 'appId/thirdPartyProvider',
  sessionParams: ['appId'],
  idAttribute: 'id',
  saveIdSessionNameAs: 'id',
  noArea: true,
  goBack: false,
  noUpdateWithId: true,
  autoUpdate: false,
  updateFormAfterSave: true,
  formConfig: [
    // formAppThirdPartyAuthProviderSetup,
    // formAppThirdPartyAuthProviderAppearance,
  ],
};
